import React, { Fragment, useEffect, useState } from 'react'
import { usePutAway } from '../../Context/usePutAway'
import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Tooltip,
  Typography
} from '@mui/material'
import { putAwayActions } from '../../actions/putAwayActions'
import StepBackPutAway from '../StepBackPutAway/StepBackPutAway'
import { useStyles } from '../DocsMatchPutAway/styles'
import LockIcon from '@mui/icons-material/Lock'
import { useConfiguration } from '../../../../hooks/useConfiguration'
import { Modal } from '../../../../components/_EOS/Modal'
import { useModal } from '../../../../hooks/useModal'
import { CheckCircle, WatchLater } from '@mui/icons-material'
import TuneIcon from '@mui/icons-material/Tune'
import { LpnState } from '../../types/enums'

interface LPNSelectionPutAwayProps {}

export const LPNSelectionPutAway: React.FC<LPNSelectionPutAwayProps> = () => {
  const { size, isOpen, title, openModal, closeModal } = useModal('Información')
  const { configurationState, getConfiguration } = useConfiguration()
  // Permite que mas de un usuario tome la misma LPN
  const [twoUserSameLPN, setTwoUserSameLPN] = useState(false)
  const [userLpnModalBloqued, setUserLpnModalBloqued] = useState('')
  const classes = useStyles()
  const { state } = usePutAway()
  const { getWorkOrderLocateByLpn } = putAwayActions()
  const { item, loading } = state

  const [searchLpn, setSearchLpn] = useState('')
  const [errorText, setErrorText] = useState('')

  const isSearchingLpnOnAvailableLpns =
    item?.lpn.filter((lpn) => lpn.lpn === searchLpn) || []

  const handleSearchFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (isSearchingLpnOnAvailableLpns?.length <= 0) {
      setErrorText('ASN no contiene el LPN indicado')
      return
    }

    if (isSearchingLpnOnAvailableLpns[0].lpnStateId === LpnState.Finished) {
      setErrorText(
        `LPN ${isSearchingLpnOnAvailableLpns[0].lpn} ya ha sido Finalizada.`
      )
      return
    }

    if (isSearchingLpnOnAvailableLpns[0].lpnStateId === LpnState.Manage) {
      setErrorText(
        `LPN ${isSearchingLpnOnAvailableLpns[0].lpn} pendiente por Gestionar.`
      )
      return
    }

    if (item) {
      getWorkOrderLocateByLpn(searchLpn, item?.asnNumber)
    } else {
      setErrorText('No se ha seleccionado un ASN')
    }
  }

  const handleSelectLPN = (
    lpn: string,
    lpnState: number,
    asnNumber: string
  ) => {
    if (lpnState === LpnState.Finished) {
      setErrorText(`LPN ${lpn} ya ha sido Finalizada.`)
      return
    }

    if (lpnState === LpnState.Manage) {
      setErrorText(`LPN ${lpn} pendiente por Gestionar.`)
      return
    }

    if (twoUserSameLPN) {
      getWorkOrderLocateByLpn(lpn, asnNumber)
    } else {
      if (item?.lpnBloqued.includes(lpn)) {
        const usuarioLpn = item?.workOrderDetails?.find((d) => d.lpn === lpn)
        setUserLpnModalBloqued(usuarioLpn?.userAlias || '')
        openModal('sm')
      } else {
        getWorkOrderLocateByLpn(lpn, asnNumber)
      }
    }
  }

  useEffect(() => {
    if (configurationState === undefined) {
      getConfiguration()
    } else {
      const externalCourierLabelConfiguration =
        configurationState.configuration.filter(
          (el) => el.name === 'AllowTwoUserOnTheSameLPN'
        )[0]

      if (externalCourierLabelConfiguration !== undefined) {
        setTwoUserSameLPN(externalCourierLabelConfiguration.value === 'true')
      }
    }
  }, [configurationState])

  const renderIconLpnState = (lpnStateId?: any) => {
    if (lpnStateId !== undefined) {
      switch (parseInt(lpnStateId, 10)) {
        case LpnState.Finished:
          return (
            <Tooltip title='Finalizado' aria-label='edit'>
              <CheckCircle style={{ color: 'green' }} />
            </Tooltip>
          )
        case LpnState.Pending:
        case LpnState.Created:
          return (
            <Tooltip title='Pendiente' aria-label='edit'>
              <WatchLater color='error' />
            </Tooltip>
          )
        case LpnState.Manage:
          return (
            <Tooltip title='Por Gestionar' aria-label='edit'>
              <TuneIcon />
            </Tooltip>
          )
      }
    }

    return ''
  }

  return (
    <div className={classes.flexContainer}>
      <StepBackPutAway />
      <Box
        component='div'
        display='flex'
        flexDirection='column'
        flexWrap='nowrap'
        alignItems='center'
        padding='10px 20px 0 20px'
      >
        {state.isUnknownScreen && (
          <Typography
            component='p'
            style={{
              fontSize: '20px',
              marginTop: '30px'
            }}
          >
            {state.titlteDocsMatch}
          </Typography>
        )}
        {!state.isUnknownScreen && (
          <React.Fragment>
            <Typography
              component='p'
              style={{
                fontSize: '20px',
                marginTop: '30px'
              }}
            >
              {`ASN ${item?.asnNumber} contiene los siguientes LPN:`}
            </Typography>
            <Typography
              component='p'
              variant='h5'
              style={{
                fontSize: '20px',
                marginBottom: '30px'
              }}
            >{`¿Cuál desea trabajar?`}</Typography>
            {!twoUserSameLPN && (
              <Typography
                component='p'
                style={{
                  fontSize: '20px'
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <LockIcon />
                  LPN está siendo trabajada por otro usuario
                </Box>
              </Typography>
            )}
          </React.Fragment>
        )}
      </Box>
      <Box
        component='div'
        display='flex'
        flexDirection='column'
        flexWrap='nowrap'
        alignItems='center'
        padding='3px'
        className={classes.container}
      >
        {loading ? (
          <CircularProgress />
        ) : (
          <Fragment>
            <form onSubmit={handleSearchFormSubmit}>
              <Box
                component='div'
                display='flex'
                flexDirection='row'
                flexWrap='nowrap'
                alignItems='center'
                padding='10px'
              >
                <TextField
                  id='searchValue'
                  name='searchValue'
                  value={searchLpn}
                  type='text'
                  onChange={(e) => {
                    setSearchLpn(e.target.value)
                  }}
                  variant='outlined'
                  fullWidth
                  label='Ingresar/Escanear LPN'
                  autoFocus
                  autoComplete='off'
                  style={{ left: '7px' }}
                  helperText={errorText || undefined}
                  error={errorText.length > 0}
                />
              </Box>
            </form>
            <Box
              component='div'
              display='flex'
              flexDirection='column'
              flexWrap='nowrap'
              alignItems='center'
              width={'90%'}
            >
              {item?.lpn.map((lpn) => (
                <Box padding={'3px'} width={'100%'}>
                  <Button
                    fullWidth
                    variant='contained'
                    onClick={() =>
                      handleSelectLPN(lpn.lpn, lpn.lpnStateId, item.asnNumber)
                    }
                  >
                    {lpn.lpn}
                    <React.Fragment>&nbsp;</React.Fragment>
                    {item?.lpnBloqued.includes(lpn.lpn) && !twoUserSameLPN && (
                      <LockIcon />
                    )}
                    {renderIconLpnState(lpn.lpnStateId)}
                  </Button>
                </Box>
              ))}
            </Box>
          </Fragment>
        )}
      </Box>
      <Modal
        open={isOpen}
        title={title}
        onClose={closeModal}
        maxWidth={size}
        cancelButton={{ title: 'Cerrar ', action: closeModal }}
      >
        <Typography>
          LPN asignada al usuario {userLpnModalBloqued}, no puede ser gestionada
          por otra persona. De ser necesario, dirigirse al menú de reasignación.
        </Typography>
      </Modal>
    </div>
  )
}
